// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.small_chatbot {
  width: 300px;  /* Set desired width */
  height: 400px; /* Set desired height */
}

.small_chatbot iframe {
  width: 100%;
  height: 100%;
}

.small_chatbot button {
  padding: 4px 8px;    /* Decrease the button padding */
  font-size: 14px;     /* Decrease the button font size */
  min-width: 10px;     /* Optionally set a minimum width */
  height: 30px;        /* Decrease the button height */
}

/* Example of targeting buttons inside the ChatBot component */
.react-rcb-chat-tooltip {
  font-size: 12px;   /* Decrease font size */
  padding: 5px 10px; /* Decrease padding to make the button smaller */
  width: auto;       /* Adjust the width as needed */
  height: auto;      /* Adjust the height as needed */
}

.rcb-chat-tooltip.rcb-tooltip-show {
  /* width: 100px !important; */
  font-size: 13px;
  bottom: 20px !important;
  right: 88px !important;
  height: 48px !important;
  background-color: #1D3D63 !important ;
}

.rcb-chat-tooltip-tail{
  border-color: transparent transparent transparent #1D3D63 !important ;
}
.rcb-toggle-button.rcb-button-show {
  width: 50px !important;
  height: 50px !important;
  font-size: 13px;
}

.rcb-chat-window{
  height: 450px !important;
  font-size: 12px !important;
  width: 440px !important;
}
.rcb-bot-message-container{
  font-size: 9px !important;
}

.rcb-chat-body-container{
font-size: small !important;
}

/* .rcb-chat-input{
height: 50px;
padding-bottom: 0 !important;
margin-bottom: 0;
font-size: small !important;
}

.rcb-bot-message-entry{
height: 25px !important;
text-align: center !important;
display: flex !important;
padding-top: 0 !important;
} */

.rcb-chat-header-container{
padding-top: 6px !important;
padding-bottom: 6px !important;
background-color: #83A4CF !important;
/* background-image: linear-gradient(right , #83A4CF , #acbdd4 ) ; */
/* background-image: linear-gradient(right ,#1D3D63, #83A4CF ) ; */
/* background-image: linear-gradient(#83A4CF) !important; */
}

.rcb-chat-footer-container{
display: none !important;
padding-top: 4px !important;
padding-bottom: 1px !important;
}

.rcb-chat-footer{
display: none;
}

.rcb-chat-input-textarea{
padding-top: 0 !important;
padding-bottom: 0 !important;
}

.rcb-chat-input{
padding-top: 2px !important;
padding-bottom: 2px !important;
}

.rcb-bot-avatar {
display: none;
}

.rcb-notification-icon-on {
display: none !important;
}

.rcb-bot-message.rcb-bot-message-entry{
font-size: 12px !important;
text-align: left;
}
.rcb-user-message.rcb-user-message-entry{
font-size: 12px !important;
}

.rcb-send-button{
background-color: #83A4CF !important;
}
.rcb-send-button:hover{
background-color: #b1c7e4!important;
}

.rcb-chat-header{
/* display: flex !important;
justify-content: center !important;
align-items: center !important;
font-size: medium !important;
width: 100%; */
/* width: -webkit-fill-available !important; */

}

.rcb-user-message.rcb-user-message-entry{
background-color: #83A4CF !important;
color: black;
}

.rcb-bot-message.rcb-bot-message-entry{
background-color: #1D3D63 !important;
}

.rcb-chat-header-container {
/* background-image: linear-gradient(to right, #83A4CF, #a9c4e8) !important; */
background-image: linear-gradient(to right, #1D3D63, #83A4CF) !important;
}

.rcb-chat-header-container > .rcb-chat-header:first-child{
display: flex !important;
justify-content: center !important;
align-items: center !important;
font-size: large !important;
width: 100%;
font-weight: 600;
}

.rcb-badge{
display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Orion/VehicleInsights_Orion/VehicleInsightOrion.css"],"names":[],"mappings":"AAAA;EACE,YAAY,GAAG,sBAAsB;EACrC,aAAa,EAAE,uBAAuB;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB,KAAK,gCAAgC;EACrD,eAAe,MAAM,kCAAkC;EACvD,eAAe,MAAM,mCAAmC;EACxD,YAAY,SAAS,+BAA+B;AACtD;;AAEA,8DAA8D;AAC9D;EACE,eAAe,IAAI,uBAAuB;EAC1C,iBAAiB,EAAE,gDAAgD;EACnE,WAAW,QAAQ,+BAA+B;EAClD,YAAY,OAAO,gCAAgC;AACrD;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,qEAAqE;AACvE;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;AACA,2BAA2B;AAC3B;;AAEA;;;;;;;;;;;;GAYG;;AAEH;AACA,2BAA2B;AAC3B,8BAA8B;AAC9B,oCAAoC;AACpC,oEAAoE;AACpE,kEAAkE;AAClE,2DAA2D;AAC3D;;AAEA;AACA,wBAAwB;AACxB,2BAA2B;AAC3B,8BAA8B;AAC9B;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,yBAAyB;AACzB,4BAA4B;AAC5B;;AAEA;AACA,2BAA2B;AAC3B,8BAA8B;AAC9B;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,wBAAwB;AACxB;;AAEA;AACA,0BAA0B;AAC1B,gBAAgB;AAChB;AACA;AACA,0BAA0B;AAC1B;;AAEA;AACA,oCAAoC;AACpC;AACA;AACA,mCAAmC;AACnC;;AAEA;AACA;;;;cAIc;AACd,8CAA8C;;AAE9C;;AAEA;AACA,oCAAoC;AACpC,YAAY;AACZ;;AAEA;AACA,oCAAoC;AACpC;;AAEA;AACA,8EAA8E;AAC9E,wEAAwE;AACxE;;AAEA;AACA,wBAAwB;AACxB,kCAAkC;AAClC,8BAA8B;AAC9B,2BAA2B;AAC3B,WAAW;AACX,gBAAgB;AAChB;;AAEA;AACA,wBAAwB;AACxB","sourcesContent":[".small_chatbot {\n  width: 300px;  /* Set desired width */\n  height: 400px; /* Set desired height */\n}\n\n.small_chatbot iframe {\n  width: 100%;\n  height: 100%;\n}\n\n.small_chatbot button {\n  padding: 4px 8px;    /* Decrease the button padding */\n  font-size: 14px;     /* Decrease the button font size */\n  min-width: 10px;     /* Optionally set a minimum width */\n  height: 30px;        /* Decrease the button height */\n}\n\n/* Example of targeting buttons inside the ChatBot component */\n.react-rcb-chat-tooltip {\n  font-size: 12px;   /* Decrease font size */\n  padding: 5px 10px; /* Decrease padding to make the button smaller */\n  width: auto;       /* Adjust the width as needed */\n  height: auto;      /* Adjust the height as needed */\n}\n\n.rcb-chat-tooltip.rcb-tooltip-show {\n  /* width: 100px !important; */\n  font-size: 13px;\n  bottom: 20px !important;\n  right: 88px !important;\n  height: 48px !important;\n  background-color: #1D3D63 !important ;\n}\n\n.rcb-chat-tooltip-tail{\n  border-color: transparent transparent transparent #1D3D63 !important ;\n}\n.rcb-toggle-button.rcb-button-show {\n  width: 50px !important;\n  height: 50px !important;\n  font-size: 13px;\n}\n\n.rcb-chat-window{\n  height: 450px !important;\n  font-size: 12px !important;\n  width: 440px !important;\n}\n.rcb-bot-message-container{\n  font-size: 9px !important;\n}\n\n.rcb-chat-body-container{\nfont-size: small !important;\n}\n\n/* .rcb-chat-input{\nheight: 50px;\npadding-bottom: 0 !important;\nmargin-bottom: 0;\nfont-size: small !important;\n}\n\n.rcb-bot-message-entry{\nheight: 25px !important;\ntext-align: center !important;\ndisplay: flex !important;\npadding-top: 0 !important;\n} */\n\n.rcb-chat-header-container{\npadding-top: 6px !important;\npadding-bottom: 6px !important;\nbackground-color: #83A4CF !important;\n/* background-image: linear-gradient(right , #83A4CF , #acbdd4 ) ; */\n/* background-image: linear-gradient(right ,#1D3D63, #83A4CF ) ; */\n/* background-image: linear-gradient(#83A4CF) !important; */\n}\n\n.rcb-chat-footer-container{\ndisplay: none !important;\npadding-top: 4px !important;\npadding-bottom: 1px !important;\n}\n\n.rcb-chat-footer{\ndisplay: none;\n}\n\n.rcb-chat-input-textarea{\npadding-top: 0 !important;\npadding-bottom: 0 !important;\n}\n\n.rcb-chat-input{\npadding-top: 2px !important;\npadding-bottom: 2px !important;\n}\n\n.rcb-bot-avatar {\ndisplay: none;\n}\n\n.rcb-notification-icon-on {\ndisplay: none !important;\n}\n\n.rcb-bot-message.rcb-bot-message-entry{\nfont-size: 12px !important;\ntext-align: left;\n}\n.rcb-user-message.rcb-user-message-entry{\nfont-size: 12px !important;\n}\n\n.rcb-send-button{\nbackground-color: #83A4CF !important;\n}\n.rcb-send-button:hover{\nbackground-color: #b1c7e4!important;\n}\n\n.rcb-chat-header{\n/* display: flex !important;\njustify-content: center !important;\nalign-items: center !important;\nfont-size: medium !important;\nwidth: 100%; */\n/* width: -webkit-fill-available !important; */\n\n}\n\n.rcb-user-message.rcb-user-message-entry{\nbackground-color: #83A4CF !important;\ncolor: black;\n}\n\n.rcb-bot-message.rcb-bot-message-entry{\nbackground-color: #1D3D63 !important;\n}\n\n.rcb-chat-header-container {\n/* background-image: linear-gradient(to right, #83A4CF, #a9c4e8) !important; */\nbackground-image: linear-gradient(to right, #1D3D63, #83A4CF) !important;\n}\n\n.rcb-chat-header-container > .rcb-chat-header:first-child{\ndisplay: flex !important;\njustify-content: center !important;\nalign-items: center !important;\nfont-size: large !important;\nwidth: 100%;\nfont-weight: 600;\n}\n\n.rcb-badge{\ndisplay: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
